import { useRef } from "react";
import { useDrop } from "react-dnd";

interface Props {
  position: number;
  setPosition: (position: number, playerId: string) => void;
}

export default function PlayerDropComponent(props: Props) {
  const { position } = props;

  const ref = useRef(null);
  const [, drop] = useDrop({
    accept: "player",
    drop(item) {
      props.setPosition(position, (item as any).id);
    },
  });

  drop(ref);
  return (
    <div
      style={{
        width: "80px",
        height: "80px",
        border: "1px dotted white",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
      }}
      ref={ref}
    ></div>
  );
}
